module.exports = __webpack_public_path__ + "img/appointment_icon_pink.6f87d58f.svg";